const EMAIL = "email";
const COMPANY = "company";
const ATOKEN = "access_token";
const TRUSTED = "trusted_token";
const RTOKEN = "refresh_token";
const REGISTER_EMAIL = "register_email";
const VIEW = "view";

const getItem = (name: string) => localStorage.getItem(name) || "";
const removeItem = (name: string) => localStorage.removeItem(name);

const setItem = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

const getStorage = () => ({
  email: getItem(EMAIL),
  company: getItem(COMPANY),
  accessToken: getItem(ATOKEN),
  trustedToken: getItem(TRUSTED),
  refreshToken: getItem(RTOKEN),
  registerEmail: getItem(REGISTER_EMAIL),
  view: (k: string) => {
    const view = localStorage.getItem("view");
    try {
      return JSON.parse(view ?? `{}`)[k];
    } catch (error) {
      console.log("🚀 ~ getStorage ~ error:", error);
    }
  },
});

const setStorage = () => ({
  setEmail: (v: string) => setItem(EMAIL, v),
  setCompany: (v: string) => setItem(COMPANY, v),
  setAccessToken: (v: string) => setItem(ATOKEN, v),
  setTrustedToken: (v: string) => setItem(TRUSTED, v),
  setRefreshToken: (v: string) => setItem(RTOKEN, v),
  setRegisterEmail: (v: string) => setItem(REGISTER_EMAIL, v),
  setView: (k: string, v: string) => {
    const pre = getItem(VIEW);
    const bol = !!pre;
    try {
      if (!bol) return setItem(VIEW, JSON.stringify({ [k]: v }));
      const obj = JSON.parse(pre);
      for (const item of Object.keys(obj)) {
        if (item === k) {
          obj[item] = v;
        } else obj[k] = v;
      }
      setItem(VIEW, JSON.stringify(obj));
    } catch (error) {
      console.log("🚀 ~ setStorage ~ error:", error);
    }
  },
});

const clearStorage = () => {
  removeItem(EMAIL);
  removeItem(COMPANY);
  removeItem(ATOKEN);
  removeItem(RTOKEN);
  removeItem(REGISTER_EMAIL);
};

export { getStorage, setStorage, clearStorage };
